import { apiClient } from '../api/client';
import { useAppQuery } from './useAppQuery';

export const createQueryHook = ({
  queryKey,
  endpoint,
  config = {},
}) => {
  return (params) => {
    const hasParams = params !== undefined && params !== null;
    
    return useAppQuery({
      queryKey: typeof queryKey === 'function' ? queryKey(params) : queryKey,
      queryFn: () => {
        const url = typeof endpoint === 'function' ? endpoint(params) : endpoint;
        return apiClient.get(url);
      },
      enabled: hasParams || params === undefined,
      ...config,
    });
  };
};

export const createListQueryHook = ({ queryKey, endpoint, config = {} }) => {
  return () => {
    const result = useAppQuery({
      queryKey,
      queryFn: () => apiClient.get(endpoint),
      ...config,
    });
    
    return {
      ...result,
      data: result.data?.data,
    };
  };
};

export const createDetailQueryHook = ({ queryKey, endpoint, config = {} }) => {
  return (id) => useAppQuery({
    queryKey: queryKey(id),
    queryFn: () => apiClient.get(endpoint(id)),
    enabled: !!id,
    ...config,
  });
};
